import React, { useState, useEffect } from 'react';
import './styles/App.css';
import BackgroundPattern from './components/BackgroundPattern';
import NavBar from './components/NavBar';
import Home from './components/Home';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Loader from './components/Loader';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Load assets when the component mounts
    fetchManifestAndAssets();
  });

  const fetchManifestAndAssets = async () => {
    try {
      const response = await fetch('/manifest.json'); // Fetch the manifest file
      const manifest = await response.json(); // Parse it as JSON

      // Load the assets
      await loadAssets(manifest.assets); // Load the assets
      setIsLoading(false); // Set loading to false when done
    } catch (error) {
      console.error("Error loading assets:", error);
      setIsLoading(false); // Make sure to update this even if there's an error
    }
  };

  const loadAssets = async (assets) => {
    const assetPromises = assets.map(asset => {
      return new Promise((resolve, reject) => {
        const img = new Image(); // Create a new image element
        img.src = asset; // Set the source to the asset
        img.onload = () => resolve(); // Resolve the promise when loaded
        img.onerror = () => reject(`Failed to load asset: ${asset}`); // Reject if there's an error
      });
    });

    return Promise.all(assetPromises); // Wait for all assets to load
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <BackgroundPattern />
          <header>
            <NavBar />
          </header>
          <main>
            <Home />
            <Skills />
            <Experience />
            <Projects />
            <Contact />
          </main>
        </>
      )}
    </>
  );
}

export default App;